import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { RequestService } from '@core/services/request/request.service';
import { OutkeepPermissionService } from '@core/services/permission/outkeep-permission.service';
import { GroupActionsViews } from '@features/requests/request-list/types';
import { RequestInstallerAssignmentFormComponent } from '../../../../../request-form/components/request-form-summary/components/request-installer-assignment-form/request-installer-assignment-form.component';

@Component({
  selector: 'x-request-installer-group-actions-view',
  imports: [
    CommonModule,
    TranslatePipe,
    RequestInstallerAssignmentFormComponent,
  ],
  templateUrl: './request-installer-group-actions-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestInstallerGroupActionsViewComponent {
  readonly $viewObserver = input.required<Subject<never>>({
    alias: 'viewObserver',
  });
  readonly $viewChanged = output<GroupActionsViews>({
    alias: 'viewChangedOutput',
  });

  private readonly destroyRef = inject(DestroyRef);
  private readonly requestService = inject(RequestService);
  private readonly permissionService = inject(OutkeepPermissionService);

  readonly canLogistChangeInstaller$ =
    this.permissionService.canLogistChangeInstaller$;
  readonly $selectedRequests = this.requestService.selectedRequests;
  readonly requestIds = computed(() =>
    this.$selectedRequests().map(({ id }) => id),
  );
  readonly ownerId = computed<number | null>(() => {
    const selectedRequests = this.$selectedRequests();

    if (!selectedRequests.length) {
      return null;
    }

    const firstOwnerId = selectedRequests[0].counterpartyOwnerId.id;

    return selectedRequests.every(
      request => request.counterpartyOwnerId.id === firstOwnerId,
    )
      ? firstOwnerId
      : null;
  });
  readonly hasMixedOwners = computed(
    () => this.$selectedRequests().length > 0 && this.ownerId() === null,
  );

  handleCompleted(): void {
    this.requestService
      .reloadSelectedRequests$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.$viewObserver().complete();
      });
  }
}
